import { Dialog } from "@material-ui/core";
import styled from "styled-components/macro";
import { DialogStyle } from "../../lib/style/Templates";

export default styled(Dialog)`
  ${DialogStyle};
`;
